<template>
  <div>

    <loading-indicator
      v-if="isLoading"
    />

    <template v-if="offer !== null">
      <dl class="row">
        <dt class="col-sm-1">Proto</dt>
        <dd class="col-sm-11">{{offer.protoId | getProtoStr}}</dd>

        <dt class="col-sm-1">State</dt>
        <dd class="col-sm-11">{{offer.state | getOfferStateName}}</dd>

        <dt class="col-sm-1">Start</dt>
        <dd class="col-sm-11">{{offer.startStamp | getMomentStr}}</dd>

        <dt class="col-sm-1">Finish</dt>
        <dd class="col-sm-11">{{offer.finishStamp | getMomentStr}}</dd>
      </dl>

      <template v-if="hasPayments">
        <offer-payment
          v-for="payment in offer.payments"
          :key="payment.sku"
          :payment="payment"
        />
      </template>

    </template>

  </div>
</template>

<script>
import { HTTP } from '../http-common';
import notifier from '../notifier';
import LoadingIndicator from './LoadingIndicator.vue';
import OfferPayment from './OfferPayment.vue';

export default {
  name: 'PlayerOfferOld',

  components: {
    LoadingIndicator,
    OfferPayment,
  },

  props: {
    playerId: {
      type: Number,
      required: true,
    },

    offerId: {
      type: Number,
      required: true,
    },
  },

  data() {
    return {
      isLoading: false,
      offer: null,
    };
  },

  computed: {
    hasPayments() {
      if(this.offer === null) {
        return false;
      }
      if(!('payments' in this.offer)) {
        return false;
      }
      return this.offer.payments.length > 0;
    },
  },

  created() {
    this.isLoading = true;

    const url = `/player/${this.playerId}/offer/${this.offerId}`;
    HTTP.get(url)
    .then(response => {
      const data = response.data.data;
      if(data === null) {
        notifier.showError('Invalid server response. data === null.', {sender: this});
        return;
      }

      this.offer = data;
    })
    .catch(e => {
      notifier.showError(e.response.data);
    })
    .finally(() => {
      this.isLoading = false;
    });
  },
};
</script>
